<!-- Formulaire d'upload -->

<!-- Template d'une carte bannette commun à tous les affichage -->
<ng-template #BasketCard>
  <div class="flex align-item-center text-gray-700 text-xl">
    <div class="mr-auto ">
      <h5 class="text-lg ml-0 pl-2" pTooltip="{{ options.Information.Name }}"
      tooltipPosition="top">{{ trunc(options.Information.Label) }}</h5>
    </div>
    <ng-container *ngTemplateOutlet="basketAction"></ng-container>
  </div>
  <div class="flex justify-content-between mt-1 flex-wrap">
    <div class="flex flex-row">
      <img
        class="mr-2 mt-3 img-hover"
        [ngSrc]="options.Information.url"
        width="75" height="75"
        priority="high"
        (error)="updateUrl(options)"
        (click)="onSelectBasket($event, options)"
        width="75"
      />
    </div>
      @if (showGradient === true && options.Information.docCount != 0) {
        <div class="flex flex-row align-item-end">
          <span class="mb-1  text-4xl text-center">
            <p-knob [valueColor]="options.Information.progressColor"
              rangeColor="#ffffffbf"
              size="75"
              [(ngModel)]="options.Information.docCount" [readonly]="true"
              [max]="options.Information.maxValue">
            </p-knob>
          </span>
        </div>
      }
      @if (showGradient === false && options.Information.docCount != 0) {
        <div class="flex flex-row doc_count ">
          {{options.Information.docCount}}
        </div>
      }
    </div>
  </ng-template>

  <ng-template #BasketCardCompact>
    <div class="flex align-item-center text-gray-700 text-xl mb-2 basket-header">
      <div class="mr-auto">
        <h5 class="text-sm ml-0 pl-2 pb-0 mb-0" pTooltip="{{ options.Information.Name }}"
          tooltipPosition="top">{{ trunc(options.Information.Label) }}
        </h5>

      </div>
      @if (options.Information.docCount != 0 && compactMode === true) {
        <span class="doc_count-compact">
          {{ options.Information.docCount }}
        </span>
      }
    </div>
    <div class="flex justify-content-between mt-1 flex-wrap basket-footer" >
      <div class="flex flex-row align-item-end">
        <img
          class="mr-2 img-hover"
          [ngSrc]=options.Information.url
          width="50" height="50"
          priority="high"
          (error)="updateUrl(options)"
          (click)="onSelectBasket($event, options)"
          width="50"
          />
          <ng-container *ngTemplateOutlet="basketAction"></ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #basketAction>
      <div class="ml-auto pl-2 flex flex-row items-center justify-between">
        <div [ngClass]="{'filter-vis': options.Information.docCount == 0 || (mode === 'disabled')}"
          class="flex flex-row items-center">
          <i pTooltip="{{'Filter_Act_1' | translate}}"
            [ngClass]="options.Information.filterBsk === true ? 'pi-filter-fill' : 'pi-filter'"
            class="text-black-alpha-90 pi text-2xl mr-1"
            (click)="onFilterBasket($event, options)">
          </i>
          @if (allowFullText===true) {
            <i
              pTooltip="{{'Srch_In' | translate}}"
              class="text-black-alpha-90 pi pi-search text-2xl mr-1"
              (click)="onFilterBasketSearch($event, options)">
            </i>
          }
        </div>
        @if (options.UserBasket.DragDrop === 'true' && mode === 'complete') {
          <span
            (click)="onUpload($event)">
            <i *ngxInputFile pTooltip="{{'Add_Doc' | translate}}"
              class="text-black-alpha-90 pi pi-plus text-2xl colorbox">
            </i>
          </span>
        }
        @if (options.UserBasket.CreationRvf === 'true' && mode === 'complete') {
          <span
            (click)="onUpload($event)">
            <i pTooltip="{{'Create_Doc' | translate}}"
              class="text-black-alpha-90 pi pi-file-export text-2xl colorbox mrg-left2"
              (click)="onAddDocBasket($event, options)">
            </i>
          </span>
        }
      </div>
    </ng-template>


    <!-- Mode Complet (complete) -->
    @if (mode === 'complete' && options.UserBasket.DragDrop === 'true') {
      <div
          [ngxDragAndDrop]="dropOptions"
          (click)="onSelectBasket($event, options)"
          [ngClass]="compactMode === true ? 'basket-compact' : 'basket'"
          [class]="'card img-hover flex flex-column basket mb-1 class' + options.Information.color + ' colorbox-' +
          options.Information.basketType"
        >
        @switch (compactMode) {
          @case (false) {
            <ng-container *ngTemplateOutlet="BasketCard"></ng-container>
          }
          @case (true) {
            <ng-container *ngTemplateOutlet="BasketCardCompact"></ng-container>
          }
        }
      </div>
    }
    @if (mode === 'complete' && options.UserBasket.DragDrop === 'false') {
      <div
          (click)="onSelectBasket($event, options)"
          [ngClass]="compactMode === true ? 'basket-compact' : 'basket'"
          [class]="'card img-hover flex flex-column basket mb-1 class' + options.Information.color + ' colorbox-' + options.Information.basketType"
        >
        @switch (compactMode) {
          @case (false) {
            <ng-container *ngTemplateOutlet="BasketCard"></ng-container>
          }
          @case (true) {
            <ng-container *ngTemplateOutlet="BasketCardCompact"></ng-container>
          }
        }
      </div>
    }
    <!-- Mode Navigation (selectable) -->
    @if (mode === 'selectable' && options.Information.docCount != 0) {
      <div
          (click)="onSelectBasket($event, options)"
          [ngClass]="compactMode === true ? 'basket-compact' : 'basket'"
          [class]="'card img-hover flex flex-column basket mb-1 class' + options.Information.color + ' colorbox-' +
          options.Information.basketType"
        >
        @switch (compactMode) {
          @case (false) {
            <ng-container *ngTemplateOutlet="BasketCard"></ng-container>
          }
          @case (true) {
            <ng-container *ngTemplateOutlet="BasketCardCompact"></ng-container>
          }
        }
      </div>
    }
    <!-- Mode Visualisation (disabled) -->
    @if (mode === 'disabled' || mode === 'move') {
      <div
        [ngClass]="{
            'basket-compact': compactMode === true,
            'basket': compactMode !== true,
            'cursor-not-allowed': mode === 'disabled'
          }"
        [class]="'card flex flex-column basket mb-1 class' + options.Information.color + ' colorbox-' +
        options.Information.basketType"
      >
        @switch (compactMode) {
          @case (false) {
            <ng-container *ngTemplateOutlet="BasketCard"></ng-container>
          }
          @case (true) {
            <ng-container *ngTemplateOutlet="BasketCardCompact"></ng-container>
          }
        }
      </div>
    }

    <form #uploadForm="ngForm">
      @if (displayUpload === true) {
        <addfile
          #addFileItem
          [uploadForm]="uploadForm"
          [bskName]="currentBasketName"
          [bskLabel]="currentBasket"
          [bskType]="currenBasketType"
          [visible]="displayUpload"
          [uploader]="uploader"
          [baseRoot]="baseRoot"
          [usePreProcess]="usePreProcess"
          [preProcessName]="preProcessName"
          [parameterList]="parameterList"
          [ctrlDouble]="ctrlDouble"
          [storagePath]="storagePath"
          [indexInputMode]="indexInputMode"
          [priority]="priority"
          (onClose)="closeAddfile()"
          (onCancel)="cancelAddfile()"
          (onRemoveItem)="removeItem($event)"
        ></addfile>
      }
    </form>